import { CancelToken } from 'axios';
import { restApi } from '../../../../services/api';
import { Classification } from '../../../classifications/classification.types';
import { AvailabilityEnum } from '../../ProductTypes';
import { ListProductColorDTO } from '../../colors/product-color.types';
import { GetProductSearchSuggestedClassificationsParams } from '../types/productSearch.types';

export interface GetProductSearchAvailabilityParams {
  productId: string;
  productColorId: string;
  orderId?: string;
}

export const onlineProductSearchRepository = (token?: CancelToken) => {
  const getProductSearchColors = (productId: string, customerId?: string) => {
    return restApi.get<ListProductColorDTO[]>(
      `/product-search/colors`,
      {
        productId,
        customerId,
      },
      { cancelToken: token },
    );
  };

  const getProductSearchAvailability = ({
    orderId,
    productColorId,
    productId,
  }: GetProductSearchAvailabilityParams) => {
    const params = new URLSearchParams({
      productId,
      productColorId,
    });

    if (orderId) {
      params.append('orderId', orderId);
    }

    return restApi.get<AvailabilityEnum[]>(
      `/product-search/availability?${params.toString()}`,
      {},
      { cancelToken: token },
    );
  };

  const getProductSearchSuggestedClassifications = ({
    productId,
    productColorId,
  }: GetProductSearchSuggestedClassificationsParams) =>
    restApi.get<Classification[]>(`/product-search/suggested-classifications`, {
      productId,
      productColorId,
    });

  return {
    getProductSearchColors,
    getProductSearchAvailability,
    getProductSearchSuggestedClassifications,
  };
};
